import base64 from "base-64";
import { env } from "@/app/_utils/env";
import type { DjangoLoginPayload } from "@/app/_utils/authTypes";

export async function postDjangoLogin(username: string, password: string) {
  const res = await fetch(`${env.apiBaseUrl}auth/login/`, {
    method: "POST",
    headers: {
      Authorization: "Basic " + base64.encode(username + ":" + password),
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
  const body = (await res.json().catch(() => null)) as
    | DjangoLoginPayload
    | { message?: string }
    | null;
  return { ok: res.ok, body };
}
